import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { Client } from "../types";

export const useClient = (client_id: string) => {
  return useQuery({
    queryKey: ["client", client_id], // Key used to cache the request
    enabled: client_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${client_id}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as Client;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
